/**
 * Resource keys of the identity token (`otto_installed_base.resources`) that
 * gate the two write paths. Reading has no key — both queries are gated by
 * node access alone — so a user without these keys still sees a declaration
 * read-only. The split is deliberate (an FSE may start what a customer
 * completes), so never collapse the two into one check.
 */
export const CONTAMINATION_DECLARATION_CREATE_RESOURCE = 'createContaminationDeclaration';
export const CONTAMINATION_DECLARATION_UPDATE_RESOURCE = 'updateContaminationDeclaration';

export interface ContaminationDeclarationAccess {
    canCreate: boolean;
    canUpdate: boolean;
}

export const getContaminationDeclarationAccess = (
    resources: ReadonlyArray<string> | null | undefined,
): ContaminationDeclarationAccess => ({
    canCreate: !!resources?.includes(CONTAMINATION_DECLARATION_CREATE_RESOURCE),
    canUpdate: !!resources?.includes(CONTAMINATION_DECLARATION_UPDATE_RESOURCE),
});
